import SnackQueueView from "@/components/SnackQueue";
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

const SnackQueue = {
  snacks: {},
  parentTop: undefined,

  close(id) {
    const snackToDelete = this.snacks[id];

    snackToDelete.$destroy();
    snackToDelete.$el.remove();
    delete this.snacks[id];

    if (this.parentTop.children.length < 1) {
      this.parentTop.remove();
      this.parentTop = undefined;
    }
  },

  open(params) {
    let parent;
    const propsData = params;

    const componentId = params.id || uuidv4();

    if (this.snacks[componentId]) {
      if (params.canClose)
        this.snacks[componentId].$data.canClose = params.canClose;
      if (params.isOpen) this.snacks[componentId].$data.isOpen = params.isOpen;
    } else if (!params.canClose) {
      propsData.closeSnack = () => {
        this.close(componentId);
      };

      const vm = typeof window !== "undefined" && window.Vue ? window.Vue : Vue;
      if (params.parent) {
        parent = params.parent;
        delete params.parent;
      }
      const QueueComponent = vm.extend(SnackQueueView);
      const component = new QueueComponent({
        parent,
        el: document.createElement("div"),
        propsData
      });
      this.parentTop = document.querySelector(
        ".snack-container.is-top.snack-queue"
      );
      if (!this.parentTop) {
        this.parentTop = document.createElement("div");
        this.parentTop.className = "snack-container is-top snack-queue";
        document.body.appendChild(this.parentTop);
      }
      this.parentTop.insertAdjacentElement("beforeend", component.$el);

      this.snacks[componentId] = component;
    }
    return this.snacks[componentId];
  }
};

export { SnackQueue };
